import { Checkbox } from '@tink/core/src/components/atoms/Checkbox/Checkbox';
import { Radio } from '@tink/core/src/components/atoms/RadioButton/Radio';
import React, { ChangeEvent } from 'react';
import { Spacer } from '@tink/core/src/components/atoms/Spacer/Spacer';
import { Text } from '../../../components/atoms/Text/Text';
import {
  AccountInfo,
  InfoWrapper,
  ItemContainer,
  Items,
  RadioWrapper,
} from './AccountListItem.styles';

export type AccountItemProps = {
  selected: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  allowSelectMultipleAccounts: boolean;
  id: string;
  name: string;
  balance?: string;
  accountNumber: string;
};

export const AccountItem: React.FC<AccountItemProps> = ({
  selected,
  onChange,
  allowSelectMultipleAccounts,
  id,
  name,
  balance,
  accountNumber,
}) => {
  return (
    <ItemContainer selected={selected} data-testid="account-item">
      {allowSelectMultipleAccounts ? (
        <div>
          <Checkbox
            checkboxSize="normedium"
            id={id}
            name={name}
            checked={selected}
            onChange={onChange}
          />
        </div>
      ) : (
        <RadioWrapper>
          <Radio value={id} name={name} id={id} checked={selected} onChange={onChange} />
        </RadioWrapper>
      )}
      <Items htmlFor={id}>
        <AccountInfo>
          <InfoWrapper>
            <Text bold data-testid="account-name">
              {name}
            </Text>
          </InfoWrapper>
        </AccountInfo>
        <Spacer size="xsmall" />
        <AccountInfo>
          <InfoWrapper>
            <Text size="small" color="secondary" data-testid="account-number">
              {accountNumber}
            </Text>
            {balance && (
              <Text size="small" color="secondary" data-testid="account-balance">
                {balance}
              </Text>
            )}
          </InfoWrapper>
        </AccountInfo>
      </Items>
    </ItemContainer>
  );
};
